import { Image, Stack, Text, Title } from "@bookingcom/bui-react";

type ErrorPageProps = {
  title: string;
  description: string;
};

export const ErrorPage = ({ title, description }: ErrorPageProps) => (
  <Stack
    direction="column"
    alignItems="center"
    justifyContent="center"
    gap={6}
    mixin={{ paddingBlockStart: 16, paddingBlockEnd: 16 }}
    attributes={{ style: { flex: 1 } }}
  >
    <Image
      asset={{
        setName: "illustrations-traveller",
        assetName: "AttractionsErrorState",
      }}
      height={51}
    />
    <Stack direction="column" alignItems="center" gap={2}>
      <Title title={title} variant="headline_3" />
      <Text variant="body_2" color="neutral_alt">
        {description}
      </Text>
    </Stack>
  </Stack>
);
